<template>
  <div :class="`expander-box ${expanderClass}`">
    <slot></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: 'expander',
  props: {
    /**
     * Three expanded states: undefined, true or false. Undefined means that there's no messing with visibility
     * which makes css easier and this component easier to use just as a normal container.
     */
    expanded: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    expanderClass() {
      return this.expanded !== undefined ? (this.expanded ? 'is-expanded' : 'is-closed') : '';
    },
  },
};
</script>
